import { IUserClaimsModel, IUserModel } from '../types'
import environment from '../../../config'
import { KeycloakResourceAccess } from 'keycloak-js'
import { updateToken } from './sessionService'
import instances from './instances'

const getClaims = (): IUserClaimsModel | undefined =>
  instances.active?.idTokenParsed as IUserClaimsModel | undefined

const getRoles = (resourceAccess: KeycloakResourceAccess | undefined): string[] =>
  resourceAccess?.[environment.auth.keycloak.clientId]?.roles ?? []

export const getUser = (): IUserModel => {
  const user: IUserModel = {
    authenticated: instances.active?.authenticated ?? false,
    info: null,
  }

  const claims = getClaims()

  if (!claims) return user

  const { name, email, resource_access: resourceAccess } = claims
  const roles = getRoles(resourceAccess)

  return { ...user, info: { name, email, roles, hasRoles: roles.length > 0 } }
}

export const getToken = async (): Promise<string | null> => {
  await updateToken()

  return instances.active?.token ?? null
}

export const getIdToken = (): string | null => {
  return instances.active?.idToken ?? null
}
